module.exports = __webpack_public_path__ + "assets/img/banner08.4fcafe50.jpg";